import { MediaRegion } from '@src/slide/application/service/media-manager/media-manager.interface';

export const INSERT_SLIDE_ORIGIN_TYPE = {
    LEFT: 1,        // 缩略图列表右键
    TOP: 2,         // 文件菜单 三道杠
    LEFT_TOP: 3,    // 缩略图列表顶部
};


export const UserModel = {
    NORMAL_MODE: 'NORMAL_MODE',         // 编辑模式
    PLAYROOM_MODE: 'PLAYROOM_MODE',     // 播放模式
};


// 测速打点：
export const SRC_NORMAL = 'src_normal';

export const RenderPostionType = {
    LEFTLIST: 'list',           // 左侧缩略图
    TEMPLATE: 'template',       // 模版
    CANVAS: 'canvas',           // 编辑区域
    MOBILEBROWSE: 'browseList',     // 移动端浏览态区域
    PAGINGSELECTION: 'pageSelection', // 幻灯片选页
    PLAYER: 'player', // 播放态下的幻灯片整页
    PRESENTER_VIEW: 'PresenterView',
    MOBILE_PLAYER_THUMBNAIL: 'mobilePlayerThumbnail', // 移动端演示态缩略图
    TRANSITION_PREVIEW: 'transitionPreview',    // 切页动画预览
};
export type RenderPostionType = typeof RenderPostionType[keyof typeof RenderPostionType];

export const RenderPositionToMediaRegion = {
    [RenderPostionType.CANVAS]: MediaRegion.EDITOR,
    [RenderPostionType.PLAYER]: MediaRegion.PLAYER,
};

export const RegionClassName = {
    PPT_EDITOR: 'ppt_editor', // PPT 编辑页面
    WORKBENCH: 'workbench', // workbench容器
};

export const PropertyEditorShowAction = {
    FROM_IMAGE_FILL: 1,     // 通过图片填充打开侧边栏
    FROM_GRADUAL_FILL: 2,    // 通过渐变填充打开侧边栏
    EFFECT_TOGGLE: 3,        // 展开所有效果侧边栏
    SHADOW_TOGGLE: 4,       // 仅展开阴影效果右侧编辑栏
    REFLECTION_TOGGLE: 5,   // 仅展开映像效果右侧编辑栏
    GLOW_TOGGLE: 6,         // 仅展开发光效果右侧编辑栏
    SOFTEDGE_TOGGLE: 7,     // 仅展开柔化效果右侧编辑栏
    TEXT_ADJUST_TOGGLE: 8,  // 默认展开文字选项
    FILL_MORE_TOGGLE: 9,   // 更多格式，标识从填充-更多格式设置入口打开侧边栏
    BORDER_MORE_TOLLGE: 10, // 更多格式，标识从边框-更多格式设置入口打开侧边栏
    IMAGE_TOGGLE: 11,  // 默认展开图片选项
    SHAPE_TOOGLE: 12,  // 设置形状格式打开侧边栏
    DOUBLE_CLICK_TOOGLE: 13, // 选中元素，双击打开侧边栏
    INSERT_FOOTER: 14,  // 通过插入页脚
    CHART_TOGGLE: 15, // 设置图表格式打开侧边栏
};

export const SelectWindowShowAction = {
    NONE: 0,
    FROM_FORMAT: 1, // 通过格式侧边栏-布局-层级打开
};

export enum CommentShowAction {
    NO_ACTION,   // 默认值
    INSERT_COMMENT,     // 通过插入批注打开侧边栏
    PREV_COMMENT_GROUP,     // 上一条批注
    NEXT_COMMENT_GROUP,     // 下一条批注
    LEFT_SLIDE_COMMENT_ANCHOR,   //  通过缩略图批注角标打开
    EDIT_SLIDE_COMMENT_ANCHOR,   //  通过编辑区批注角标打开
}

export enum ShowActionSource {
    TOOLBAR,    // 工具栏
    RIGHT_MENU, // 右键菜单
    SHORT_CUT,  // 快捷键
    DRAWER, // 侧边栏
}

/**
 * 一些通用的常量key
 * @type {{EDITOR_FRAME: string}}
 */
export const KEY = {
    EDITOR_FRAME: 'editor-iframe',
};

/**
 * For Mobile UI
 */
export const MOBILE_HEAD_HEIGHT = 44;
export const MOBILE_BOTTOM_HEIGHT = 44;
export const MOBILE_NATIVE_JUDGE_HEIGHT = 88;
export const MOBILE_SLIDEBAR_HEIGHT = 90;
export const MOBILE_SLIDEBAR_WIDTH = 120;
export const EDIT_MODE_SLIDE_WIDTH = 100;
export const EDIT_MODE_SLIDE_EXTRA_HEIGHT = 33.75;

export const OPERATION_TYPE = {
    FONT_SIZE: 'font-size',
    FONT_SIZE_UP: 'font-size-up',
};

export const INIT_FOCUS = 'initFocus';

// 插件类型
export const ADDON_TYPE = {
    FORMULA: 'formula',
    INSERT: 'insert',
    SIGN: 'sign',
    UNOFFICIAL: 'unOfficial',
};

export const TEXT_CHANGE = 'textChange';

// header头部栏类型
export const ToolbarType = {
    SINGLE_TOOLBAR: '1',    // 简约单栏
    DOUBLE_TOOLBAR: '2',    // 经典双栏
};

export const MULTI = 'multi';

export const RENDER_MODE = {
    CANVAS: 'canvas',
    DOM: 'dom',
};

export const NAME_TOOL_HEIGHT = 44;

export const MEMO_WINDOW_FLAG = '1';

export const LINK_HEIGHT = 36;

export const DEFAULT_MIMETYPE = 'application-vnd.tdocs-apps.default';
